(function (root) {
  "use strict";

  root.LUVIRE_IDEAL_PARTNER_READINGS = {
    woman: {
      1: {
        title: "The Self-Directed Leader",
        profile: "You naturally take initiative and prefer to shape your own path. Independence, competence, and a clear sense of direction are central to the way you move through life.",
        traits: ["Secure in themselves", "Collaborative rather than competitive", "Accountable and dependable", "Respectful of your independence"],
        insight: "Your strongest connection is likely to feel like a true alliance. You thrive with a partner who can stand beside you, contribute confidently, and share responsibility.",
        prompt: "Where could an equal partnership help you release control and make more room for trust?"
      },
      2: {
        title: "The Intuitive Heart",
        profile: "You are perceptive, emotionally attuned, and sensitive to what is happening beneath the surface. You often notice subtle shifts that others overlook.",
        traits: ["Emotionally steady", "Reliable and consistent", "Clear in their communication", "Protective without being controlling"],
        insight: "Your sensitivity flourishes with reassurance and emotional consistency. Clear boundaries can help you stay connected without losing sight of your own needs.",
        prompt: "What signs of consistency help you feel safe while remaining true to yourself?"
      },
      3: {
        title: "The Radiant Muse",
        profile: "You bring ideas, warmth, and expressive energy wherever you go. Curiosity and inspiration are essential parts of your romantic world.",
        traits: ["Curious and ambitious", "Intellectually engaging", "Energetic enough to match your pace", "Respectful of your freedom"],
        insight: "You need both stimulation and space, but consistency gives your inspiration somewhere meaningful to land. The right connection feels lively without becoming unreliable.",
        prompt: "What balance of novelty and consistency helps you feel most alive in love?"
      },
      4: {
        title: "The Practical Strategist",
        profile: "You approach life with reason, practicality, and a strong appreciation for stability. You value results, follow-through, and relationships that can be trusted.",
        traits: ["Financially responsible", "Disciplined and consistent", "Reliable in everyday life", "Emotionally mature and flexible"],
        insight: "Order and dependability help you relax, but a relationship does not have to function like a project. Warmth, playfulness, and a little spontaneity can complement the stability you value.",
        prompt: "Where could you welcome more flexibility without giving up the security you need?"
      },
      5: {
        title: "The Free Spirit",
        profile: "You are adaptable, magnetic, and energized by possibility. Freedom matters to you, especially the freedom to grow, explore, and remain fully yourself.",
        traits: ["Confident and emotionally secure", "Trusting rather than controlling", "Open-minded", "Curious and engaging"],
        insight: "Freedom and closeness can coexist when expectations are transparent and boundaries are chosen together. The right relationship gives you space without creating emotional distance.",
        prompt: "Which freedoms are essential to you, and which agreements make closeness feel safe?"
      },
      6: {
        title: "The Devoted Heart",
        profile: "Love, family, and emotional depth are important to you. You are naturally drawn to relationships in which care is expressed openly and consistently.",
        traits: ["Dependable", "Generous with time and attention", "Emotionally attentive", "Ready for meaningful commitment"],
        insight: "You thrive when care is both given and received. Love feels more secure when needs are expressed clearly rather than left for a partner to guess.",
        prompt: "What kind of everyday care helps you feel genuinely cherished?"
      },
      7: {
        title: "The Quiet Depth",
        profile: "You are thoughtful, independent, and naturally drawn to ideas with substance. You may take time to open up, but your inner world is rich and perceptive.",
        traits: ["Thoughtful and intelligent", "Calm", "Comfortable with quiet", "Respectful of privacy and boundaries"],
        insight: "A low-drama relationship can still include emotional vulnerability. Gentle, direct communication helps another person understand the depth you may not immediately show.",
        prompt: "What helps you feel safe enough to share what you usually keep private?"
      },
      8: {
        title: "The Purposeful Powerhouse",
        profile: "You are ambitious, capable, and comfortable pursuing meaningful goals. You are unlikely to feel fulfilled in a relationship that asks you to make yourself smaller.",
        traits: ["Confident and secure", "Financially grounded", "Purposeful and goal-oriented", "Able to celebrate your strength"],
        insight: "The most supportive partnership allows both people to grow and share influence without turning love into a competition. Your strength does not need to be diminished for connection to thrive.",
        prompt: "What does sharing power look like without reducing your ambition?"
      },
      9: {
        title: "The Soulful Original",
        profile: "You are creative, reflective, and comfortable seeing the world differently. Authenticity and emotional depth matter more to you than fitting a conventional mold.",
        traits: ["Self-aware", "Accepting of your individuality", "Respectful of your personal space", "Emotionally or spiritually mature"],
        insight: "You flourish with someone who approaches your inner world with curiosity rather than judgment. A connection built only on surface-level compatibility may feel limiting.",
        prompt: "Which parts of yourself need to be welcomed rather than explained away?"
      }
    },
    man: {
      1: {
        title: "The Grounded Leader",
        profile: "You are comfortable taking initiative and creating direction. Responsibility matters to you, and you tend to feel most engaged when your contribution is recognized.",
        traits: ["Appreciative without idealizing you", "Independent and self-assured", "Warm and emotionally expressive", "Respectful of your ambitions"],
        insight: "Healthy leadership leaves room for both people to influence the relationship. Admiration feels best alongside honesty, mutual respect, and shared decision-making.",
        prompt: "What would shared leadership look like when both partners' needs matter equally?"
      },
      2: {
        title: "The Hearth Keeper",
        profile: "You value closeness, loyalty, comfort, and a strong sense of home. You are naturally drawn to relationships that feel sincere, warm, and dependable.",
        traits: ["Calm under pressure", "Affectionate and gentle", "Emotionally consistent", "Interested in building a committed life"],
        insight: "You are at your best in a relationship that feels peaceful and secure. Lasting harmony comes from addressing important feelings with care, not from avoiding every disagreement.",
        prompt: "How can you create stability while still making space for necessary conversations?"
      },
      3: {
        title: "The Magnetic Spark",
        profile: "You are energized by movement, expression, and emotional connection. You enjoy relationships that feel vivid, engaging, and full of shared experiences.",
        traits: ["Lively and engaging", "Confident in their own identity", "Thoughtful about self-care", "Able to maintain healthy boundaries"],
        insight: "Your best match can enjoy your energy without trying to control it or disappearing inside it. Playfulness becomes more fulfilling when supported by clear boundaries and genuine intimacy.",
        prompt: "When does attention feel connecting, and when can it become a substitute for deeper closeness?"
      },
      4: {
        title: "The Steady Anchor",
        profile: "Responsibility and long-term commitment matter deeply to you. You often express love by creating structure, solving problems, and showing that others can rely on you.",
        traits: ["Loyal and dependable", "Calm and grounded", "Respectful of shared values", "Able to express their own perspective"],
        insight: "Commitment feels strongest when responsibility is shared rather than carried by one person. Mutual respect includes supporting each other's decisions while remaining open to honest dialogue.",
        prompt: "Which responsibilities would you most like a partner to share with you?"
      },
      5: {
        title: "The Adventurous Catalyst",
        profile: "You are drawn to excitement, movement, and meaningful wins. Energy and momentum help you feel engaged with both life and love.",
        traits: ["Active and enthusiastic", "Confident in their own style", "Encouraging of your goals", "Open to novelty and adventure"],
        insight: "Routine does not have to mean stagnation. A compatible partner can share your appetite for adventure while helping create a dependable foundation beneath it.",
        prompt: "How can you keep excitement alive without depending on constant change?"
      },
      6: {
        title: "The Caring Protector",
        profile: "You show love through care, responsibility, and practical support. Creating safety for the people closest to you often feels deeply meaningful.",
        traits: ["Gentle and emotionally warm", "Thoughtful about self-care and shared space", "Openly appreciative", "Willing to create a nurturing atmosphere together"],
        insight: "You flourish when care and appreciation move in both directions. Supporting someone does not require carrying everything alone.",
        prompt: "Where could you allow a partner to care for you, rather than always being the caregiver?"
      },
      7: {
        title: "The Principled Core",
        profile: "You value sincerity, integrity, and clear principles. Trust matters deeply, and you are most comfortable when words and actions align.",
        traits: ["Honest and direct", "Emotionally steady", "Respectful of trust and boundaries", "Secure rather than manipulative"],
        insight: "Loyalty grows through transparency and calm reassurance. Jealousy tests rarely create real security; clear agreements and honest conversations do.",
        prompt: "What honest conversation could strengthen trust without putting it to the test?"
      },
      8: {
        title: "The Purposeful Achiever",
        profile: "You bring determination and momentum to the goals that matter to you. Progress feels energizing, especially when it is connected to a larger purpose.",
        traits: ["Motivating and encouraging", "Confident in their own presence", "Supportive of your goals", "Collaborative rather than competitive"],
        insight: "Support can amplify your drive, but a relationship is more than productivity. Mutual fulfillment means making room for your partner's aspirations as well as your own.",
        prompt: "How can you pursue your goals while making equal room for your partner's ambitions?"
      },
      9: {
        title: "The Meaning Seeker",
        profile: "You are sincere, generous, and motivated by a sense of purpose. In relationships, shared meaning often matters as much as attraction.",
        traits: ["Guided by clear values", "Intellectually curious", "Open to meaningful commitment", "Respectful of your sense of purpose"],
        insight: "You may be drawn to meaning more than appearances, but lasting closeness also grows through practical, everyday compatibility.",
        prompt: "Which shared values would make a relationship feel purposeful to you?"
      }
    }
  };

  if (typeof document !== "undefined" && document.addEventListener) {
    document.addEventListener("luvire:calculator-completed", function (event) {
      const app = event.target;
      if (!app || app.getAttribute("data-calculator-key") !== "ideal_partner") return;
      const chooser = app.querySelector(".lc-love-chooser--date-first");
      const form = app.querySelector("[data-lc-form]");
      const result = app.querySelector("[data-lc-result]");
      const offer = app.querySelector("[data-lc-offer]");
      if (!chooser || !form || !result) return;

      const reset = document.createElement("button");
      reset.type = "button";
      reset.className = "lc-result-reset";
      reset.setAttribute("data-lc-reset", "");
      reset.textContent = "Calculate again";
      result.appendChild(reset);
      chooser.hidden = true;

      reset.addEventListener("click", function () {
        form.reset();
        form.querySelectorAll("[aria-invalid='true']").forEach(function (field) {
          field.removeAttribute("aria-invalid");
        });
        app.removeAttribute("data-reading-choice");
        app.querySelectorAll("[data-lc-reading-choice]").forEach(function (choice) {
          choice.setAttribute("aria-pressed", "false");
        });
        const panel = app.querySelector(".lc-love-form-panel");
        if (panel) panel.classList.remove("is-ready");
        const error = app.querySelector("[data-lc-error]");
        if (error) {
          error.textContent = "";
          error.hidden = true;
        }
        result.classList.remove("is-visible");
        result.hidden = true;
        result.textContent = "";
        if (offer) offer.hidden = true;
        chooser.hidden = false;
        const status = app.querySelector("[data-lc-status]");
        if (status) status.textContent = "Calculator reset. Enter your birth date and select your gender.";
        const month = form.querySelector('[data-lc-date-part="month"]');
        const reduced = root.matchMedia && root.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const revealForm = function () {
          chooser.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
          if (month) month.focus({ preventScroll: true });
        };
        if (typeof root.requestAnimationFrame === "function") root.requestAnimationFrame(revealForm);
        else root.setTimeout(revealForm, 0);
      });
    });
  }
}(typeof window !== "undefined" ? window : globalThis));
